import { render, staticRenderFns } from "./handlerEnvauthority.vue?vue&type=template&id=3984d84e&scoped=true&"
import script from "./handlerEnvauthority.vue?vue&type=script&lang=js&"
export * from "./handlerEnvauthority.vue?vue&type=script&lang=js&"
import style0 from "./handlerEnvauthority.vue?vue&type=style&index=0&id=3984d84e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3984d84e",
  null
  
)

export default component.exports